import {Stack, Text, Button} from '@treatwell/ui';
import {useTranslation} from 'react-i18next';
import {useAppSelector} from '../../hooks/store';
import {
  selectRescheduleStartDate,
  selectRescheduleStartTime,
} from '../../store/slices/reschedule/slice';
import {formatDate} from '../../../shared/utils/date';
import RescheduleSuccessIcon from './icon-booking-confirmed.svg';
import styles from './RescheduleSuccess.module.css';

interface Props {
  labels: {
    success: string;
    buttonLabel: string;
    rescheduleInfo: string;
  };
}

export const RescheduleSuccess = ({labels}: Props) => {
  const redirectToAccount = (): void => window.location.assign('/account');

  return (
    <div className={styles.root}>
      <Stack
        space="2xl"
        align="center"
        justify="center"
        fullHeight
        data-cy="RescheduleSuccess"
      >
        <RescheduleSuccessIcon />
        <Stack as="section" space="sm" align="center" className={styles.text}>
          <Text as="h1" type="mdHeader">
            {labels.success}
          </Text>
          <Text as="p">{labels.rescheduleInfo}</Text>
        </Stack>
        <div className={styles.button}>
          <Button data-cy="RedirectAccount" onClick={redirectToAccount}>
            {labels.buttonLabel}
          </Button>
        </div>
      </Stack>
    </div>
  );
};

export const RescheduleSuccessContainer = () => {
  const {t} = useTranslation();
  const startTime = useAppSelector(selectRescheduleStartTime);
  const startDate = useAppSelector(selectRescheduleStartDate);

  if (!startTime || !startDate) {
    return null;
  }

  const formattedDate = formatDate(startDate, 'DD MMMM YYYY');
  const success = t('reschedule.successMessage');
  const buttonLabel = t('reschedule.button');
  const rescheduleInfo = t('reschedule.rescheduleInfo', {
    date: formattedDate,
    time: startTime,
  });

  return (
    <RescheduleSuccess
      labels={{
        success: success,
        buttonLabel: buttonLabel,
        rescheduleInfo: rescheduleInfo,
      }}
    />
  );
};
